const cities = [
  {
    id: 12,
    name: 'Tangerang',
  },
  {
    id: 124,
    name: 'Jakarta',
  },
  {
    id: 22,
    name: 'Bandung',
  },
  {
    id: 24,
    name: 'Bogor',
  },
  {
    id: 126,
    name: 'Lombok',
  },
  {
    id: 127,
    name: 'Bali',
  },
  {
    id: 99,
    name: 'Yogyakarta',
  },
];

export default cities;
